import {
  DeleteButton
} from "./chunk-UWNWOSVP.mjs";

// src/views/Files/FileItem/FileItem.tsx
import { Box, Flex, Text } from "@chakra-ui/react";
import { InfoBox } from "@airhelp/info-box";
import { Documents } from "@airhelp/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var sizeInMB = (sizeInBytes) => (sizeInBytes / (1024 * 1024)).toFixed(2);
var FileItemIcon = () => /* @__PURE__ */ jsx(Box, {
  border: "1px solid",
  borderColor: "greyscale.400",
  bg: "greyscale.100",
  borderRadius: "md",
  p: 3,
  children: /* @__PURE__ */ jsx(Documents, {
    w: 5,
    h: 5,
    color: "primary.500"
  })
});
var FileItem = ({ file, onDelete }) => /* @__PURE__ */ jsx(InfoBox, {
  variant: "secondary",
  icon: /* @__PURE__ */ jsx(FileItemIcon, {}),
  w: "100%",
  gap: 2,
  display: "flex",
  flexDirection: "row",
  justifyContent: "left",
  children: /* @__PURE__ */ jsxs(Flex, {
    display: "flex",
    direction: "row",
    justify: "space-between",
    w: "100%",
    children: [
      /* @__PURE__ */ jsxs(Flex, {
        direction: "column",
        basis: 0,
        grow: 1,
        children: [
          /* @__PURE__ */ jsx(Text, {
            fontSize: "sm",
            fontWeight: "bold",
            color: "greyscale.700",
            wordBreak: "break-word",
            children: file.name
          }),
          /* @__PURE__ */ jsxs(Text, {
            fontSize: "sm",
            color: "greyscale.600",
            children: [
              sizeInMB(file.size),
              " MB"
            ]
          })
        ]
      }),
      onDelete && /* @__PURE__ */ jsx(Box, {
        ml: 3,
        children: /* @__PURE__ */ jsx(DeleteButton, {
          onClick: () => onDelete(file)
        })
      })
    ]
  })
});

export {
  FileItem
};
